
import { Vue } from 'vue-class-component';
import * as countryAreaCode from '@/assets/data/countryAreaCode.json';
import CurrentUserService from '@/services/currentUserService';
import ErrorCode from '@/constants/ErrorCode';
import { ElMessage } from 'element-plus';
import CommonValidate from '@/services/commonValidate';
import UpdateSelfInfoModel from '@/models/userInfos/updateSelfInfoModel';
import UserInfoService from '@/services/userInfoService';

export default class Personal extends Vue {
  private countryAreaCodes = (countryAreaCode as any).default;

  private userInfo = CurrentUserService.GetUserInfo();

  private model=new UpdateSelfInfoModel();

  private rules= {
    nickName: [
      { required: true, message: '请输入账号昵称', trigger: 'blur' }, { validator: CommonValidate.validateNickName, trigger: 'blur' },
    ],
    phonePrefix: [
      { required: true, message: '请输入选择地区', trigger: 'change' },
    ],
    phoneNo: [{ required: true, message: '请输入手机号码', trigger: 'blur' }, { validator: CommonValidate.validatePhone, trigger: 'blur' }],
  };

  mounted(): void {
    this.loadData();
  }

  back(): void {
    this.$router.push('/');
  }

  save(): void {
    const form = this.$refs.updateForm as any;
    form.validate((valid: boolean) => {
      if (valid) {
        UserInfoService.updateMyInfo(this.model).then((response) => {
          if (response.code === ErrorCode.Success) {
            ElMessage.success(response.msg);
          } else {
            ElMessage.error(response.msg);
          }
        }).catch((err) => {
          if (err && err.msg) {
            ElMessage.error(err.msg);
          } else {
            ElMessage.error('操作失败');
          }
        });
      }
    });
  }

  loadData(): void {
    UserInfoService.getMyInfo()
      .then((result) => {
        if (result.code === ErrorCode.Success) {
          this.model.nickName = result.data.nickName;
          this.model.creationDate = result.data.creationDate;
          this.model.contacts = result.data.contacts;
          this.model.address = result.data.address;
          this.model.phoneNo = result.data.phoneNo?.split('-')[1] as string;
          this.model.phonePrefix = result.data.phoneNo?.split('-')[0] as string;
        } else {
          ElMessage.error(result.msg);
        }
      })
      .catch((response) => {
        console.log(response);
        if (response) {
          ElMessage.error(response);
        }
      });
  }
}
